import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Layout',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Layout" */ '../components/layouts/index.vue'),
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "content" */ '../components/content/index.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/list',
        name: 'list',
        component: () => import(/* webpackChunkName: "content" */ '../views/list/index.vue'),
        meta: {
          title: '资讯列表'
        }
      },
      {
        path: '/information',
        name: 'information',
        component: () => import(/* webpackChunkName: "information" */ '../views/information.vue'),
        children: [
          {
            path: '/information/news01',
            name: 'news01',
            component: () => import(/* webpackChunkName: "notice01" */ '../views/news/news01.vue'),
            meta: {
              title: '最新'
            }
          },
          {
            path: '/information/news02',
            name: 'news02',
            component: () => import(/* webpackChunkName: "notice01" */ '../views/news/news02.vue'),
            meta: {
              title: '最新'
            }
          },
          {
            path: '/information/news03',
            name: 'news03',
            component: () => import(/* webpackChunkName: "notice01" */ '../views/news/news03.vue'),
            meta: {
              title: '最新'
            }
          },
          {
            path: '/information/news04',
            name: 'news04',
            component: () => import(/* webpackChunkName: "notice01" */ '../views/news/news04.vue'),
            meta: {
              title: '最新'
            }
          },
          {
            path: '/information/news05',
            name: 'news05',
            component: () => import(/* webpackChunkName: "notice01" */ '../views/news/news05.vue'),
            meta: {
              title: '最新'
            }
          },
          {
            path: '/information/news06',
            name: 'news06',
            component: () => import(/* webpackChunkName: "notice01" */ '../views/news/news06.vue'),
            meta: {
              title: '最新'
            }
          },
          {
            path: '/information/news07',
            name: 'news07',
            component: () => import(/* webpackChunkName: "notice01" */ '../views/news/news07.vue'),
            meta: {
              title: '最新'
            }
          },
          {
            path: '/information/news08',
            name: 'news08',
            component: () => import(/* webpackChunkName: "notice01" */ '../views/news/news08.vue'),
            meta: {
              title: '最新'
            }
          },
          {
            path: '/information/news09',
            name: 'news09',
            component: () => import(/* webpackChunkName: "notice01" */ '../views/news/news09.vue'),
            meta: {
              title: '最新'
            }
          },
          {
            path: '/information/news10',
            name: 'news10',
            component: () => import(/* webpackChunkName: "notice01" */ '../views/news/news10.vue'),
            meta: {
              title: '最新'
            }
          },
          {
            path: '/information/news11',
            name: 'news11',
            component: () => import(/* webpackChunkName: "notice01" */ '../views/news/news11.vue'),
            meta: {
              title: '最新'
            }
          },
        ]
      },
      {
        path: '/about',
        name: 'about',
        component: () => import(/* webpackChunkName: "about" */ '../views/about.vue'),
        meta: {
          title: '关于我们'
        }
      },
    ]
  }
]

const router = createRouter({
  mode: 'hash',
  history: createWebHashHistory(),
  routes
})




export default router
